import "./index.sass";
import { useTranslation } from "@helpers/translate";

const RSI_MIN_VALUE = 0;
const RSI_MAX_VALUE = 100;

const getThumbPosition = (value) => {
  if (!Number.isFinite(value)) {
    return 50;
  }

  return Math.min(Math.max(value, RSI_MIN_VALUE), RSI_MAX_VALUE);
};

const AverageCrypto = ({ value, formattedValue = "--", isLoading = false }) => {
  const { __ } = useTranslation();

  const rsiValue = Number(value);
  const thumbPosition = getThumbPosition(rsiValue);

  return (
    <div className="average-crypto">
      <div className="average-crypto__header">
        <span className="average-crypto__title">
          {__("markets.averageCryptoRsi")}
        </span>
      </div>

      <div className="average-crypto__value">
        {isLoading ? "--" : formattedValue}
      </div>

      <div className="average-crypto__labels">
        <span>{__("markets.oversold")}</span>
        <span>{__("markets.overbought")}</span>
      </div>

      <div className="average-crypto__slider">
        <div className="average-crypto__segment average-crypto__segment--gold" />
        <div className="average-crypto__segment average-crypto__segment--gray" />
        <div className="average-crypto__segment average-crypto__segment--pink" />

        <div
          className="average-crypto__thumb"
          style={{ left: `${thumbPosition}%` }}
        />
      </div>
    </div>
  );
};

export default AverageCrypto;